import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'
import { APIError, toQueryString } from '@sales-center/common'
import { StateProvince } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/automatedAssignment/States`

export const getStatesList = createAsyncThunk<
  { name: string; abbreviation: string }[],
  string | undefined,
  { rejectValue: APIError }
>('dictionaries/states', async (countryCode, thunkApi) => {
  let url = baseUrl

  if (countryCode) {
    url = `${baseUrl}?${toQueryString({ countryCode })}`
  }

  const response = await get(url)

  if (response.ok) {
    const payload: { name: string; abbreviation: string }[] =
      await response.json()
    return payload
  } else {
    const json = await response.json()
    return thunkApi.rejectWithValue(json)
  }
})

export const getAllStatesProvincesList = createAsyncThunk<
  StateProvince[],
  string | undefined,
  { rejectValue: APIError }
>('dictionaries/states/all', async (_, thunkApi) => {
  const response = await get(`${baseUrl}/All`)

  if (response.ok) {
    const payload: StateProvince[] = await response.json()
    return payload
  } else {
    const json = await response.json()
    return thunkApi.rejectWithValue(json)
  }
})
